/* DataRetentionRenderer.js */

/* global Slick */
const uiCore = require("@gluenetworks/steve_ui_core");
const ScheduleComponent = require("@gluenetworks/schedule_component");
const ButtonControl = uiCore.Control.Action.Button;
const CheckboxControl = uiCore.Control.Boolean.InputCheckbox;
const InputRadioControl = uiCore.Control.OptionSelection.Single.InputRadio;
const _ = require("lodash");
const $ = require("jquery");
//Used to help calculate the height of the table
const SLICKOFFSETS = {
    staticElementsHeight: 206,
    scheduleHeightElement: 140,
    tableSpacing: 30,
    rowHeight: 45,
};

// const InputTextControl = uiCore.Control.Textfield.InputText;

class DataRetentionRenderer {
    constructor(model, uiUtils) {
        this._model = model;
        this._uiUtils = uiUtils;
        this._isComponentNotInShutdownState = true;
        this._rootElem = document.createElement("data-retention-gl");
        this._rootElem.component = this._model;

        this._tableOptions = {
            editable: true,
            enableAddRow: false,
            enableCellNavigation: true,
            enableColumnReorder: false,
            forceFitColumns: false,
            enableAsyncPostRender: true,
            asyncEditorLoading: false,
            rowHeight: 45,
            autoHeight: false,
            resizable: true,
        };
        this._headerElem = document.createElement("h1");
        this._headerElem.innerText = "Data Retention";

        this._policyEnable = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "Enable Unique Data Retention Policy for this Organization",
            title: "Create a separate data retention policy for the current organization (Not available for the root or topmost organization)",
        });

        this._scheduleEnabledLabel = document.createElement("label");
        this._scheduleEnabledLabel.innerText = "Run Options";
        this._scheduleEnabledLabel.title = "Run data retention on demand or on a schedule";
        this._scheduleEnabled = new InputRadioControl({
            darkTheme: true,
            horizontal: true,
            options: [
                {
                    label: "Manual",
                    title: "Run data retention on demand only",
                    value: false,
                },
                {
                    label: "Scheduled",
                    title: "Specify a schedule for running data retention",
                    value: true,
                },
            ],
            value: this._model.scheduleEnabled || false,
        });
        this._scheduleEnabledContainer = document.createElement("div");
        this._scheduleEnabledContainer.classList.add("schedule-enable-container");
        this._scheduleEnabledContainer.appendChild(this._scheduleEnabledLabel);
        this._scheduleEnabledContainer.appendChild(this._scheduleEnabled.renderer.getRootElement());

        this._frequencyScheduleContainer = document.createElement("div");
        this._frequencyScheduleContainer.classList.add("schedule-container");
        this._scheduleFrequencyComponent = new ScheduleComponent(undefined, {
            allowOne: false,
            allowRepeat: true,
            pollOnly: false,
            availOnly: true,
            disabled: this._model.scheduleEnabled || false,
            noStartingEnding: true,
        });
        this._scheduleFrequencyComponent.theme = "dark";
        this._frequencyScheduleLabel = document.createElement("label");
        this._frequencyScheduleLabel.innerText = "Frequency";

        this._dataRetentionPolicyContainer = document.createElement("div");
        this._dataRetentionPolicyContainer.classList.add("data-container");
        this._slickTableContainer = document.createElement("data-retention-policy-table");
        this._dataRetentionPolicyLabel = document.createElement("label");
        this._dataRetentionPolicyLabel.innerText = "Data Retention Policy";

        this._controlButtonsContainer = document.createElement("div");
        this._controlButtonsContainer.classList.add("control-buttons");

        this._runPolicyButton = new ButtonControl({
            label: "Run All Now",
            title: "Run the data retention policy for all categories for the current organization and any child organizations that inherit it",
            darkTheme: true,
        });
        this._updateCUButton = new ButtonControl({
            label: "Preview All",
            title: "Populate the count of records to purge in the Preview column",
            darkTheme: true,
        });
        this._cancelButton = new ButtonControl({
            label: "Cancel",
            title: "Cancel the current retention policy changes",
            darkTheme: true,
        });
        this._savePolicyButton = new ButtonControl({
            label: "Save",
            title: "Save the current retention policy settings",
            active: true,
            darkTheme: true,
        });

        this._controlButtonsContainer.appendChild(this._updateCUButton.renderer.getRootElement());
        this._controlButtonsContainer.appendChild(this._runPolicyButton.renderer.getRootElement());
        this._controlButtonsContainer.appendChild(this._cancelButton.renderer.getRootElement());
        this._controlButtonsContainer.appendChild(this._savePolicyButton.renderer.getRootElement());

        this._slickTable = undefined;

        this._columns = [
            {
                id: "name",
                width: 312,
                name: "Category",
                toolTip: "Activity or status that details and logs are stored for",
                field: "name",
                resizable: false,
            },
            {
                id: "description",
                width: 509,
                name: "Description",
                toolTip: "Details about the category",
                field: "description",
            },
            {
                id: "usage",
                width: 60,
                name: "Preview",
                toolTip:
                    "Number of records that would be removed, based on the current retention policy. Populated by clicking preview",
                field: "usage",
                resizable: false,
            },

            {
                id: "min",
                width: 60,
                name: "Count",
                toolTip: "Minimum number of records to retain for the category per device",
                field: "min",
                editor: Slick.Editors.Text,
                resizable: false,
            },
            {
                id: "age",
                width: 60,
                name: "Age",
                toolTip: "Maximum number of days for records to be retained",
                field: "age",
                editor: Slick.Editors.Text,
                resizable: false,
            },
            /*
            {
                id: "archiveData",
                width: 60,
                name: "Archive",
                toolTip: "Records that meet the criteria will be archived as a text file and removed from the database",
                field: "archiveData",
                cannotTriggerInsert: true,
                formatter: this._rowCheckbox.bind(this),
                editor: Slick.Editors.Checkbox,
                resizable: false
            },

             */
            {
                id: "actions",
                //width: 178,
                width: 188,
                name: "Action",
                toolTip: "Run or preview the data retention policy for the category",
                field: "actions",
                resizable: false,
                formatter: this._rowButtonsCellRender.bind(this),
                asyncPostRender: this._renderButtonsContainer.bind(this),
            },
        ];

        this._rowButtons = []; // store slickgrid buttons to easy manipulate the items
        //this._rowCheckboxes = []; // store slickgrid checkboxes to easy manipulate the items

        this._fitTableSize = this._fitTableSize.bind(this);
        this._clickHandler = this._clickHandler.bind(this);
        this.reloadDataRetentionView = this.reloadDataRetentionView.bind(this);
        this._saveAndCloseEditCell = this._saveAndCloseEditCell.bind(this);
        this._purgeAllHandler = this._purgeAllHandler.bind(this);
        this._runNowHandler = this._runNowHandler.bind(this);
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        this.isComponentNotInShutdownState = false;
        this._unregisterListeners();
        this._uiUtils.clearMessage();

        const promArr = [
            this._runPolicyButton.shutdown,
            this._updateCUButton.shutdown,
            this._cancelButton.shutdown,
            this._savePolicyButton.shutdown,
            this._scheduleEnabled.shutdown,
            this._scheduleFrequencyComponent.shutdown,
        ];

        return Promise.all(promArr).then(() => {
            this._model = undefined;
            this._tableOptions = undefined;
            this._headerElem.remove();
            this._headerElem = undefined;
            this._policyEnable = undefined;
            this._scheduleEnabledLabel.remove();
            this._scheduleEnabledLabel = undefined;
            this._scheduleEnabled = undefined;
            this._scheduleEnabledContainer.remove();
            this._scheduleEnabledContainer = undefined;
            this._frequencyScheduleContainer.remove();
            this._frequencyScheduleContainer = undefined;
            this._scheduleFrequencyComponent = undefined;
            this._frequencyScheduleLabel.remove();
            this._frequencyScheduleLabel = undefined;
            this._dataRetentionPolicyContainer.remove();
            this._dataRetentionPolicyContainer = undefined;
            this._slickTableContainer.remove();
            this._slickTableContainer = undefined;
            this._dataRetentionPolicyLabel.remove();
            this._dataRetentionPolicyLabel = undefined;
            this._controlButtonsContainer.remove();
            this._controlButtonsContainer = undefined;
            this._runPolicyButton = undefined;
            this._updateCUButton = undefined;
            this._cancelButton = undefined;
            this._savePolicyButton = undefined;
            this._slickTable = undefined;
            this._columns = undefined;
            this._rowButtons = undefined;
            //this._rowCheckboxes = undefined;
            this._uiUtils = undefined;
            this._fitTableSize = undefined;
            this._clickHandler = undefined;
            this.reloadDataRetentionView = undefined;
            this._saveAndCloseEditCell = undefined;
            this._purgeAllHandler = undefined;
            this._runNowHandler = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            this._isComponentNotInShutdownState = undefined;
        });
    }

    _registerListeners() {
        this._model.on("Shutdown", this._onShutdown.bind(this));
        this._model.on("DataRetentionPropertiesUpdated", this.reloadDataRetentionView.bind(this));
        this._model.on("DataRetentionOrganizationChanged", this.reloadDataRetentionData.bind(this));
        this._model.on(
            "ExecutionStatsPropertyUpdated",
            this._executionStatsPropertyUpdatedHandler.bind(this)
        );
        this._model.on(
            "PreviewStatsPropertyUpdated",
            this._previewStatsPropertyUpdatedHandler.bind(this)
        );
        this._policyEnable.on("UserValue", this._policyEnableChangeHandler.bind(this));
        this._scheduleEnabled.on("UserValue", this._scheduleEnabledChangeHandler.bind(this));
        this._scheduleFrequencyComponent.on("UserValue", this._scheduleChangeHandler.bind(this));
        this._savePolicyButton.on("UserClick", this._saveDataRetentionConfig.bind(this));
        this._runPolicyButton.on("UserClick", this._executeDataRetention.bind(this));
        this._cancelButton.on("UserClick", this._cancelCurrentChanges.bind(this));
        this._updateCUButton.on("UserClick", this._updateAllCurrentUsage.bind(this));
        window.addEventListener("click", this._clickHandler);
        window.addEventListener("resize", this._fitTableSize);
        if (this._slickTable) {
            this._slickTable.onKeyDown.subscribe(this._gridKeyDownHandler.bind(this));
        }
    }

    _unregisterListeners() {
        this._model.removeAllListeners("Shutdown");
        this._model.removeAllListeners("DataRetentionPropertiesUpdated");
        this._model.removeAllListeners("DataRetentionOrganizationChanged");
        this._model.removeAllListeners("ExecutionStatsPropertyUpdated");
        this._model.removeAllListeners("PreviewStatsPropertyUpdated");
        this._scheduleFrequencyComponent.removeListener("UserValue", this._scheduleChangeHandler);
        this._savePolicyButton.removeListener("UserClick", this._saveDataRetentionConfig);
        this._scheduleEnabled.removeListener("UserValue", this._scheduleEnabledChangeHandler);
        this._policyEnable.removeListener("UserValue", this._policyEnableChangeHandler);
        this._runPolicyButton.removeListener("UserClick", this._executeDataRetention);
        this._cancelButton.removeListener("UserClick", this._cancelCurrentChanges);
        this._updateCUButton.removeListener("UserClick", this._updateAllCurrentUsage);
        window.removeEventListener("click", this._clickHandler);
        window.removeEventListener("resize", this._fitTableSize);
        if (this._slickTable) {
            this._slickTable.onKeyDown.unsubscribe();
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (this.model) {
            return this.model.whenModelIsReady().then(() => {
                if (this._scheduleFrequencyComponent) {
                    //set default schedule value
                    if (this._model.schedule) {
                        this._scheduleFrequencyComponent.setSchedule(this._model.schedule);
                    } else {
                        this._setDefaultSchedule();
                    }

                    this._scheduleFrequencyComponent.renderer
                        .render()
                        .then(() => {
                            this._rootElem.appendChild(this._headerElem);
                            this._rootElem.appendChild(
                                this._policyEnable.renderer.getRootElement()
                            );
                            this._policyEnable.setValue(this._model._isDataRetentionPolicyEnabled);

                            this._rootElem.appendChild(this._scheduleEnabledContainer);

                            if (this._model.isDataRetentionPolicyLocked === true) {
                                this._policyEnable.setDisabled(
                                    this._model.isDataRetentionPolicyLocked
                                );
                            }

                            if (this._model._isSysOrgDataRetentionPolicy) {
                                this._scheduleEnabled.renderer._setDisabled(false);
                                this._scheduleEnabled.setValue(this._model.scheduleEnabled);
                                this._scheduleFrequencyCollapse(!this._model.scheduleEnabled);
                            } else {
                                this._scheduleEnabled.renderer._setDisabled(
                                    !this._model._isDataRetentionPolicyEnabled
                                );
                                this._scheduleEnabled.setValue(this._model.scheduleEnabled);
                                this._scheduleFrequencyCollapse(
                                    !this._model._isDataRetentionPolicyEnabled ||
                                        !this._model.scheduleEnabled,
                                    !this._model.scheduleEnabled
                                );
                            }

                            this._switchCheckboxes(this._model._isSysOrgDataRetentionPolicy);

                            this._frequencyScheduleContainer.appendChild(
                                this._frequencyScheduleLabel
                            );
                            this._frequencyScheduleContainer.appendChild(
                                this._scheduleFrequencyComponent.renderer.rootElement
                            );
                            this._rootElem.appendChild(this._frequencyScheduleContainer);

                            this._dataRetentionPolicyContainer.appendChild(
                                this._dataRetentionPolicyLabel
                            );
                            this._dataRetentionPolicyContainer.appendChild(
                                this._slickTableContainer
                            );
                            this._rootElem.appendChild(this._dataRetentionPolicyContainer);

                            this._rootElem.appendChild(this._controlButtonsContainer);
                            this._slickTable = new Slick.Grid(
                                this._slickTableContainer,
                                {},
                                this._columns,
                                this._tableOptions
                            );

                            return this.setSlickGridTableData(this._model.dataRetentionConfigCopy);
                        })
                        .then(() => {
                            if (!this._model._isDataRetentionPolicyEnabled) {
                                this._disableEditRows();
                            } else {
                                this._enableEditRows();
                            }

                            this._registerListeners();

                            this._fitTableSize(); // fix windows os slickgrid resize issue

                            return Promise.resolve();
                            //return this._updateCurrentUsage(true);
                        });
                }
            });
        }
    }

    /**
     * Only updates the view
     * @returns {Promise}
     */
    reloadDataRetentionView() {
        if (this._model.schedule) {
            this._scheduleFrequencyComponent.setSchedule(this._model.schedule);
        } else {
            this._setDefaultSchedule();
        }

        this._switchCheckboxes(this._model._isSysOrgDataRetentionPolicy);

        this._policyEnable.setValue(this._model._isDataRetentionPolicyEnabled);

        if (this._model._isSysOrgDataRetentionPolicy) {
            this._scheduleEnabled.renderer._setDisabled(false);
            this._scheduleEnabled.setValue(this._model.scheduleEnabled);
            this._scheduleFrequencyCollapse(!this._model.scheduleEnabled);
        } else {
            this._scheduleEnabled.renderer._setDisabled(!this._model._isDataRetentionPolicyEnabled);
            this._scheduleEnabled.setValue(this._model.scheduleEnabled);
            this._scheduleFrequencyCollapse(
                !this._model._isDataRetentionPolicyEnabled || !this._model.scheduleEnabled,
                !this._model.scheduleEnabled
            );
        }

        return this.setSlickGridTableData(this._model.dataRetentionConfigCopy).then(() => {
            if (!this._model._isDataRetentionPolicyEnabled) {
                this._disableEditRows();
            } else {
                this._enableEditRows();
            }
            if (this._model.isDataRetentionPolicyLocked === true) {
                this._policyEnable.setDisabled(true);
            } else if (this._policyEnable.isDisabled()) {
                this._policyEnable.setDisabled(false);
            }

            this._fitTableSize(); // fix windows os slickgrid resize issue

            return Promise.resolve();
        });
    }

    /**
     * update the policy data from the server, and reload the view
     */
    reloadDataRetentionData() {
        this._model._unregisterListeners();
        return this._model.getPolicyData().then(() => {
            this._model._registerListeners();
            this._updateCUButton.disabled = false;
            this._runPolicyButton.disabled = false;
            this._runPolicyButton.label = "Run All Now";
            this._updateCUButton.label = "Preview All";
            return this.reloadDataRetentionView();
        });
    }

    /**
     * populate the slickGrid, and reload it
     * @param {Array} newData - new data to populate the slickGrid
     */
    setSlickGridTableData(newData) {
        if (newData) {
            return new Promise((resolve) => {
                this._slickTable.setData(newData);
                this._slickTable.invalidate();
                this._slickTable.render();
                this._fitTableSize(); // fix windows os slickgrid resize issue
                return resolve();
            });
        }
    }

    /**
     * get and converts the current dataRetentionConfig data, right before send it to the backend
     * @param { number= } row - pass a row number if you need only a specific row, otherwise all grid will be returned
     * @returns { Promise }
     */
    getCurrentConvertedDataRetentionConfig(row) {
        return new Promise((resolve) => {
            let policyArgs;
            const convertedData = {};
            const dataRetention = this._slickTable.getData();
            // If row is not specified, return an array of all data retention policies
            if (row) {
                policyArgs = Object.assign({}, dataRetention[row]);
                const objectKey = policyArgs.objectKey;
                delete policyArgs.name;
                delete policyArgs.description;
                delete policyArgs.minDescription;
                delete policyArgs.objectKey;
                delete policyArgs.actions;
                delete policyArgs.usage;
                //slick grid store user values as strings, so we must convert them before save
                policyArgs.min = _.parseInt(policyArgs.min, 10);
                convertedData[objectKey] = policyArgs;
            } else {
                policyArgs = dataRetention.map((a) => Object.assign({}, a));
                for (let i = 0; i < policyArgs.length; i++) {
                    const row = policyArgs[i];
                    const objectKey = row.objectKey;
                    delete row.name;
                    delete row.description;
                    delete row.minDescription;
                    delete row.objectKey;
                    delete row.actions;
                    delete row.usage;
                    row.min = _.parseInt(row.min, 10);
                    convertedData[objectKey] = row;
                }
            }

            return resolve(convertedData);
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    get isComponentNotInShutdownState() {
        return this._isComponentNotInShutdownState;
    }

    set isComponentNotInShutdownState(newValue) {
        this._isComponentNotInShutdownState = newValue;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    /**
     * Switch visibility of "Enable Unique Data Retention Policy" checkbox for system org
     * @param {boolean} isSystemOrg
     */
    _switchCheckboxes(isSystemOrg = false) {
        if (isSystemOrg) {
            this._policyEnable.emit("Visible", false);
        } else {
            this._policyEnable.emit("Visible", true);
        }
    }

    /**
     * Buttons(Run Now, Purge All) cell render
     * @param {number} row
     * @param {number} cell
     * @param {string} value - the status value
     */
    _rowButtonsCellRender(row, cell, value /*, columnDef, dataContext*/) {
        const buttonContainer = document.createElement("div"),
            buttonState = value && value.state ? value.state : undefined,
            buttonStateMode = value && value.mode ? value.mode : undefined;

        buttonContainer.classList.add("button-group");
        const runNowButton = new ButtonControl({darkTheme: true, label: "Run Now"});
        const previewButton = new ButtonControl({darkTheme: true, label: "Preview"});
        //const purgeAllButton = new ButtonControl({darkTheme: true, label: "Purge All"});

        runNowButton.setAttribute("row", row).setAttribute("data-action", "run");
        previewButton.setAttribute("row", row).setAttribute("data-action", "preview");
        //purgeAllButton.setAttribute('row', row).setAttribute('data-action', 'purge');

        if (
            buttonStateMode !== "preview" &&
            (buttonState === "running" || buttonState === "queued")
        ) {
            runNowButton.disabled = true;
            previewButton.disabled = true;
            //purgeAllButton.disabled = true;
            runNowButton.label = _.capitalize(buttonState) + "...";
            previewButton.label = _.capitalize(buttonState) + "...";
            //purgeAllButton.label = _.capitalize(buttonState) + "...";
        } else {
            runNowButton.disabled = false;
            previewButton.disabled = false;
            //purgeAllButton.disabled = false;
            runNowButton.label = "Run Now";
            previewButton.label = "Preview";
            //purgeAllButton.label = "Purge All";
        }

        buttonContainer.appendChild(previewButton.renderer.getRootElement());
        buttonContainer.appendChild(runNowButton.renderer.getRootElement());

        this._rowButtons[row] = buttonContainer;

        return buttonContainer.outerHTML; // we will rewrite that outerHTML in _renderButtonsContainer()
    }

    /**
     * Rewrite _rowButtonsCellRender outerHTML, to have ability select elements from array, but not from the DOM
     * @param {Object} cellNode
     * @param {number} row
     */
    _renderButtonsContainer(cellNode, row /*, dataContext, colDef*/) {
        if (cellNode[0].childElementCount > 0) {
            cellNode[0].children[0].remove();
        }
        if (this.isComponentNotInShutdownState === true) {
            cellNode[0].appendChild(this._rowButtons[row]);
        }
    }

    /**
     * Archive checkbox cell render
     * @param {number} row
     * @param {number} cell
     * @param {boolean} value
     */
    /*
    _rowCheckbox(row, cell, value) {
        let checkbox = document.createElement("div");
        if (value) {
            checkbox = document.createElement("base-icon-gl");
            checkbox.dataset.icon = 'common.check';
        }

        this._rowCheckboxes[row] = checkbox;

        return checkbox.outerHTML; // we will rewrite that outerHTML in _renderCheckboxes()
    }

     */

    /**
     * Rewrite _rowCheckbox outerHTML, to have ability select elements from array, but not from the DOM
     * @param {Object} cellNode
     * @param {number} row
     */
    /*
    _renderCheckboxes(cellNode, row) {
        if (cellNode[0].childElementCount > 0) {
            cellNode[0].children[0].remove();
        }
        cellNode[0].appendChild(this._rowCheckboxes[row]);
    }

     */

    /**
     * Disable/Enable and Hide/Show schedule control
     * @param {boolean} disable
     * @param {boolean=} hide - optional parameter, if you need also to hide the control
     */
    _scheduleFrequencyCollapse(disable, hide) {
        const hideSchedule = typeof hide !== "undefined" ? hide : disable;
        this._scheduleFrequencyComponent.setDisabledSchedule(disable);
        if (hideSchedule && !this._frequencyScheduleContainer.classList.contains("hide-control")) {
            this._frequencyScheduleContainer.classList.add("hide-control");
        } else if (
            !hideSchedule &&
            this._frequencyScheduleContainer.classList.contains("hide-control")
        ) {
            this._frequencyScheduleContainer.classList.remove("hide-control");
        }
        this._fitTableSize();
    }

    /**
     * set "Save" button availability
     */
    _setSavePolicyButtonAvailability() {
        const policyEnabled = this._policyEnable.value,
            currentData = this._slickTable.getData(),
            currentSchedule = this._scheduleFrequencyComponent.schedule,
            currentScheduleEnabled = this.model.scheduleEnabled,
            savedData = this._model._dataRetentionConfig, // Make a copy of dataRetention config from SlickGrid so it can be compared with model
            savedSchedule = this._model._retentionPolicyOrgInstance.schedule,
            savedScheduleEnabled = this._model._retentionPolicyOrgInstance.scheduleEnabled,
            isDataMatch = this._uiUtils.isItemsMatch(currentData, savedData);

        // Check if something has been changed
        //_.isMatch(currentSchedule, savedSchedule)
        if (
            policyEnabled === true &&
            (!isDataMatch ||
                ((currentScheduleEnabled || savedScheduleEnabled) &&
                    !this._matchSchedules(currentSchedule, savedSchedule)) ||
                savedScheduleEnabled !== currentScheduleEnabled)
        ) {
            // Enable the button
            this._savePolicyButton.disabled = false;
            this._cancelButton.disabled = false;
            this._updateCUButton.disabled = true;
            this._runPolicyButton.disabled = true;
            this._disableRowButtons();
            return true;
        } else {
            //Conditions to enable button are not met, disable the 'Save' button
            this._savePolicyButton.disabled = true;
            this._cancelButton.disabled = true;
            this._updateCUButton.disabled = false;
            this._runPolicyButton.disabled = false;
            this._enableRowButtons();
            return false;
        }
    }

    _matchSchedules(currentSchedule, savedSchedule) {
        if (currentSchedule.tz !== savedSchedule.tz) {
            const convertedSchedule = this._scheduleFrequencyComponent.getScheduleAtTimeZone(
                currentSchedule,
                savedSchedule.tz
            );
            return _.isMatch(convertedSchedule, savedSchedule);
        }
        return _.isMatch(currentSchedule, savedSchedule);
    }

    _disableRowButtons() {
        const runButtons = this._rowButtons; //document.querySelectorAll('button-control[data-action="run"]');
        for (let i = 0; i < runButtons.length; i++) {
            runButtons[i].children[0].setAttribute("disabled", "disabled");
        }
    }

    _enableRowButtons() {
        const runButtons = this._rowButtons; //document.querySelectorAll('button-control[data-action="run"]');
        for (let i = 0; i < runButtons.length; i++) {
            runButtons[i].children[0].removeAttribute("disabled");
        }
    }

    _disableEditRows() {
        /*
        const checkboxes = this._rowCheckboxes; //document.querySelectorAll('input[type="checkbox"]');
        for (let i = 0; i < checkboxes.length; i++) {
            if (!checkboxes[i].disabled) {
                checkboxes[i].setAttribute("disabled", true);
            }
        }

         */
        if (this._slickTableContainer.classList.contains("editable")) {
            this._slickTableContainer.classList.remove("editable");
        }
        this._savePolicyButton.disabled = true;
        this._cancelButton.disabled = true;

        if (this._slickTable.getOptions().editable === true) {
            this._slickTable.setOptions({editable: false});
        }
    }

    _enableEditRows() {
        /*
        const checkboxes = this._rowCheckboxes; //document.querySelectorAll('input[type="checkbox"]');
        for (let i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].disabled === true) {
                checkboxes[i].removeAttribute("disabled");
            }
        }
         */

        if (!this._slickTableContainer.classList.contains("editable")) {
            this._slickTableContainer.classList.add("editable");
        }
        this._slickTable.setOptions({editable: true});

        this._setSavePolicyButtonAvailability();
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /**
     *
     * @param {Array} newData
     * @param {boolean} isStatusComplete - is all items are in 'Complete' status
     */
    _executionStatsPropertyUpdatedHandler(newData, isStatusComplete) {
        this.setSlickGridTableData(newData).then(() => {
            if (isStatusComplete === true) {
                this._enableEditRows();
                this._runPolicyButton.disabled = false;
                this._runPolicyButton.label = "Run All Now";
            } else {
                this._disableEditRows();
                this._runPolicyButton.disabled = true;
            }
        });
    }

    _previewStatsPropertyUpdatedHandler(newData, isStatusComplete) {
        this.setSlickGridTableData(newData).then(() => {
            if (isStatusComplete === true) {
                this._enableEditRows();
                this._updateCUButton.disabled = false;
                this._updateCUButton.label = "Preview All";
            } else {
                this._disableEditRows();
                this._updateCUButton.disabled = true;
            }
        });
    }

    _scheduleEnabledChangeHandler(value) {
        this.model.setScheduleEnabled(value);
        this._scheduleFrequencyCollapse(!value);
        this._setSavePolicyButtonAvailability();
    }

    _clickHandler(event) {
        if (event.target.localName === "button-control" && !event.target.attributes.disabled) {
            const item = event.target;

            switch (item.innerText) {
                case "Save":
                    this._saveAndCloseEditCell();
                    break;
                case "Run Now":
                    //edit action
                    this._runNowHandler(item.getAttribute("row"));
                    break;
                case "Preview":
                    this._runPreviewHandler(item.getAttribute("row"));
                    break;
                case "Purge All":
                    //edit action
                    this._purgeAllHandler(item.getAttribute("row"));
                    break;
            }
        }
        if (
            event.target.tagName !== "INPUT" &&
            event.target.tagName !== "BUTTON-CONTROL" &&
            this._slickTable.getOptions().editable
        ) {
            this._saveAndCloseEditCell();
        }
    }

    /**
     * Enter key handler
     * @param {Object<Event>} e
     */
    _gridKeyDownHandler(e) {
        if (e.which === 13) {
            this._saveAndCloseEditCell(true);
        }
    }

    _policyEnableChangeHandler() {
        if (_.get(this._policyEnable, "value") === true) {
            this._model._retentionPolicyOrgInstance.detachFromAscendantOrg();
            this._enableEditRows();
            this._model.setDataRetentionPolicyEnabled(true);
            this._scheduleEnabled.renderer._setDisabled(false);
            if (typeof this._model._retentionPolicyOrgInstance.scheduleEnabled !== "undefined") {
                this._scheduleEnabled.setValue(
                    this._model._retentionPolicyOrgInstance.scheduleEnabled
                );
                this._model.setScheduleEnabled(
                    this._model._retentionPolicyOrgInstance.scheduleEnabled
                );
            } else {
                this._scheduleEnabled.setValue(this._model.scheduleEnabled);
            }
            this._scheduleFrequencyCollapse(!this._model.scheduleEnabled);
            this._fitTableSize(); // fix windows os slickgrid resize issue
            this._model._retentionPolicyOrgInstance.update().catch((err) => {
                if (_.get(err, "errorCode") !== "NoPendingUpdates") {
                    this._uiUtils.showMessageDialog({
                        message: "An error occurred: " + this._uiUtils.errorCodeMapping(err),
                        confirmButtonName: "OK",
                    });
                    this.reloadDataRetentionData();
                }
            });
        } else {
            this._uiUtils
                .showDeleteConfirmDialog({
                    message:
                        "The Data Retention Policy will be updated to use the Policy defined by the parent organization and cannot be modified. Do you wish to continue?",
                    confirmButtonName: "Confirm",
                    cancelButtonName: "Cancel",
                })
                .then(
                    () => {
                        this._model.setDataRetentionPolicyEnabled(false);
                        this._model._retentionPolicyOrgInstance
                            .reattachToAscendantOrg()
                            .then(() => {
                                this.reloadDataRetentionData();
                            })
                            .catch((err) => {
                                if (_.get(err, "errorCode") !== "NoPendingUpdates") {
                                    this._uiUtils.showMessageDialog({
                                        message:
                                            "An error occurred: " +
                                            this._uiUtils.errorCodeMapping(err),
                                        confirmButtonName: "OK",
                                    });
                                    this.reloadDataRetentionData();
                                }
                            });
                    },
                    () => {
                        // Cancelled
                        this._policyEnable.setValue(true);
                    }
                );
        }
    }

    _scheduleChangeHandler(dateTime) {
        this._model.setSchedule(dateTime);
        this._setSavePolicyButtonAvailability();
    }

    // Save button click
    _saveDataRetentionConfig() {
        this._saveAndCloseEditCell();
        this._uiUtils.clearMessage();
        if (this.model._retentionPolicyOrgInstance.scheduleEnabled !== this.model.scheduleEnabled) {
            this._model._retentionPolicyOrgInstance.setScheduleEnabled(this.model.scheduleEnabled);
        }
        // Only provide min/perInstanceMin, age and archiveData properties for each data category
        this._model._retentionPolicyOrgInstance.setSchedule(this._model.schedule);
        try {
            this.getCurrentConvertedDataRetentionConfig()
                .then((data) => this._model._retentionPolicyOrgInstance.setPolicyArgs(data))
                .then(() => this._model._retentionPolicyOrgInstance.update())
                .catch((err) => {
                    if (_.get(err, "errorCode") !== "NoPendingUpdates") {
                        if (err.errorMsg) {
                            this._uiUtils.showMessageDialog({
                                message:
                                    "An error occurred: " + this._uiUtils.errorCodeMapping(err),
                                confirmButtonName: "OK",
                            });
                        } else {
                            this._uiUtils.writeErrorMessage("Validation " + err);
                        }
                        this.reloadDataRetentionData();
                    }
                });
        } catch (err) {
            this._uiUtils.writeErrorMessage(
                "Validation error: " + this._uiUtils.errorCodeMapping(err)
            );
            this.reloadDataRetentionData();
        }
    }

    _cancelCurrentChanges() {
        this.reloadDataRetentionData();
    }

    _updateAllCurrentUsage() {
        return this._updateCurrentUsage(true);
    }

    // Preview archive counts button click handler
    _updateCurrentUsage(silent = true, row) {
        this._clickedRow = row;
        return this.getCurrentConvertedDataRetentionConfig(row)
            .then((data) => {
                const element =
                    this._dataRetentionPolicyContainer.querySelectorAll('[data-action="preview"]');
                if (this._clickedRow && element && element[this._clickedRow]) {
                    //element[this._clickedRow].setHTML("Running...");
                    element[this._clickedRow].innerHtml = "Running...";
                } else {
                    this._updateCUButton.label = "Running...";
                }
                this._updateCUButton.disabled = true;
                return this._model._retentionPolicyOrgInstance.runPreview(data);
            })
            .catch((err) => {
                if (this._updateCUButton) {
                    this._updateCUButton.disabled = false;
                    this._updateCUButton.label = "Preview All";
                }

                if (silent) {
                    return Promise.resolve();
                } else {
                    this._uiUtils.showMessageDialog({
                        message: "An error occurred: " + this._uiUtils.errorCodeMapping(err),
                        confirmButtonName: "OK",
                    });
                }
            });
    }

    // Run all policy button click handler
    _executeDataRetention(/*{orgId:<orgId>, dataRetentionConfig: {....}*/) {
        this._uiUtils
            .showDeleteConfirmDialog({
                message:
                    "Run the Data Retention Policy for all categories now? Data will purged based on the current settings and may not be recoverable.",
                confirmButtonName: "Confirm",
                cancelButtonName: "Cancel",
            })
            .then(
                () => {
                    // Only provide min/perInstanceMin, age property for each data category
                    return this.getCurrentConvertedDataRetentionConfig().then((policyArgs) => {
                        this._runPolicyButton.label = "Running...";
                        this._runPolicyButton.disabled = true;
                        return this._model._retentionPolicyOrgInstance
                            .runArchiveAndPurge(policyArgs)
                            .then(() => {
                                return this._model._retentionPolicyOrgInstance.runPreview(
                                    policyArgs
                                );
                            });
                    });
                },
                () => {
                    Promise.resolve();
                }
            )
            .catch((err) => {
                this._uiUtils.showMessageDialog({
                    message: "An error occurred: " + this._uiUtils.errorCodeMapping(err),
                    confirmButtonName: "OK",
                });
                this._runPolicyButton.disabled = false;
                this._runPolicyButton.label = "Run All Now";
            });
    }

    _runNowHandler(row) {
        const data = this._slickTable.getData();
        const rowName = data[row].name;
        this._uiUtils
            .showDeleteConfirmDialog({
                message: `Run the Data Retention Policy for the ${rowName} category now?  Data will be purged based on the current settings and may not be recoverable.`,
                confirmButtonName: "Confirm",
                cancelButtonName: "Cancel",
            })
            .then(() => {
                return this.getCurrentConvertedDataRetentionConfig(row);
            })
            .then(
                (policyArgs) => {
                    return this._model._retentionPolicyOrgInstance
                        .runArchiveAndPurge(policyArgs)
                        .then(() => {
                            return this._model._retentionPolicyOrgInstance.runPreview(policyArgs);
                        });
                },
                () => {
                    Promise.resolve();
                }
            )
            .catch((err) => {
                this._uiUtils.showMessageDialog({
                    message: "An error occurred: " + this._uiUtils.errorCodeMapping(err),
                    confirmButtonName: "OK",
                });
            });
    }

    _runPreviewHandler(row) {
        if (row) {
            this._updateCurrentUsage(false, row).then(() => {
                Promise.resolve();
            });
        }
    }

    _purgeAllHandler(row) {
        const data = this._slickTable.getData();
        const rowName = data[row].name;
        this._uiUtils
            .showDeleteConfirmDialog({
                message: `Purge all data for the ${rowName} category now?  Data will not be recoverable.`,
                confirmButtonName: "Confirm",
                cancelButtonName: "Cancel",
            })
            .then(() => {
                return this.getCurrentConvertedDataRetentionConfig(row).then((policyArgs) => {
                    const previewPolicyArgs = _.clone(policyArgs);
                    _.mapKeys(policyArgs, (config, category) => {
                        //delete policyArgs[category].archiveData;
                        delete policyArgs[category].minAgeConstraint;
                        policyArgs[category].min = 0;
                        policyArgs[category].age = _.parseInt(_.get(config, "minAgeConstraint", 0));
                    });
                    return this._model._retentionPolicyOrgInstance.runPurge(policyArgs).then(() => {
                        return this._model._retentionPolicyOrgInstance.runPreview(
                            previewPolicyArgs
                        );
                    });
                });
            })
            .catch((err) => {
                this._uiUtils.showMessageDialog({
                    message: "An error occurred: " + this._uiUtils.errorCodeMapping(err),
                    confirmButtonName: "OK",
                });
            });
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _saveAndCloseEditCell(navigateDown) {
        //Remove editing mode from cells, on clicking outside the table
        if (this._slickTable && this._slickTable.getEditorLock().isActive()) {
            this._slickTable.getEditorLock().commitCurrentEdit();
        }
        if (this._slickTable && navigateDown) {
            this._slickTable.navigateDown();
            this._slickTable.navigateUp();
        }
        this._setSavePolicyButtonAvailability();
    }

    _fitTableSize() {
        if (this._slickTable) {
            // To get around a limitiation in slickgrid, we have to resize the table element manually
            // Dynamically calculate the height of the table based on the number of rows and the height of the schedule
            // Table conatiner height must also be dynamically calculated
            const scheduleHeightElement = this._scheduleEnabled.value
                ? SLICKOFFSETS.scheduleHeightElement
                : 0;
            const slicktableHeight =
                this._slickTable.getData().length * SLICKOFFSETS.rowHeight +
                SLICKOFFSETS.tableSpacing;
            $("data-retention-gl .data-container").height(
                $("data-retention-gl").height() -
                    SLICKOFFSETS.staticElementsHeight -
                    scheduleHeightElement
            );
            $("data-retention-policy-table").height(slicktableHeight); // eslint-disable-line no-undef
            this._slickTable.render();
        }
    }

    _setDefaultSchedule() {
        const defaultSchedule = ScheduleComponent.defaultValue({
            allowOne: false,
            allowRepeat: true,
            pollOnly: false,
            availOnly: true,
        });
        this._scheduleFrequencyComponent.setSchedule(defaultSchedule, false);
        this._model.setSchedule(defaultSchedule);
    }

    _onShutdown() {
        this._shutdown();
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = DataRetentionRenderer;
